import { Outlet } from "react-router-dom";

export default function GuestListPage() {
  return <Outlet />;
}
